import { Grid } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { MarkdownContent } from '@backstage/core-components';
import { GridItem } from '../GridItem';

// Helper function to render field content consistently
const renderFieldContent = (
  value: string | undefined,
  useMarkdown: boolean = true,
  fallback: string = 'Not specified',
) => {
  // Handle empty strings and undefined values
  const cleanValue = value?.trim();
  const content = cleanValue || fallback;

  if (!useMarkdown) {
    return content;
  }

  return <MarkdownContent content={content} dialect="common-mark" />;
};

export interface EntityDescriptionProps {
  entity: Entity;
}

export const EntityDescription: React.FC<EntityDescriptionProps> = ({
  entity,
}) => (
  <Grid container>
    <GridItem
      label="Description"
      value={renderFieldContent(entity.metadata.description, true)}
      gridSizes={{ xs: 12 }}
    />
  </Grid>
);
